var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-nav",on:{"mouseenter":_vm.handleMouseIn,"mouseleave":_vm.handleMouseOut}},_vm._l((_vm.navs),function(nav,index){return _c('div',{key:index,staticClass:"w-nav-item",class:{
    'w-nav-item-active': _vm.first_path === nav.path
      },on:{"click":function($event){$event.stopPropagation();return _vm.handleNav(nav)}}},[_vm._v(" "+_vm._s(nav.title)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }